import { CellContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { Stack } from 'src/core/ui';

import { BaseCell, BaseCellProps } from './BaseCell';
import * as styles from './IconTextCell.css';

export interface IconTextCellValue {
  text?: string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
}

export interface IconTextCellProps<TData = unknown>
  extends IconTextCellValue,
    Omit<BaseCellProps, 'children'> {
  context?: CellContext<TData, IconTextCellValue>;
}

export function IconTextCell<TData>({
  context,
  ...props
}: IconTextCellProps<TData>) {
  const value = context?.getValue() || {
    text: props.text,
    iconLeft: props.iconLeft,
    iconRight: props.iconRight,
  };

  if (!value) return <BaseCell {...props} />;

  return (
    <BaseCell
      {...props}
      isFullWidth={Boolean(value.iconRight)}
      showPadding={false}
    >
      <Stack
        justifyContent="spaceBetween"
        alignItems="center"
        style={{ width: '100%' }}
      >
        <Stack
          gap={'s'}
          alignItems="center"
          style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}
        >
          {value.iconLeft && (
            <span className={styles.icon}>{value.iconLeft}</span>
          )}
          <span className={styles.text}>{value.text}</span>
        </Stack>
        {value.iconRight && (
          <span className={styles.icon}>{value.iconRight}</span>
        )}
      </Stack>
    </BaseCell>
  );
}
